import { useContext, useMemo } from "react";
import MDSpinner from "react-md-spinner";
import { AppContext } from "../../../Util/contexts/AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import getIconFromCategoryString from "../../../Util/functions/getIconFromCategoryString";
import { ExamCreatorContext } from "../../../Util/contexts/ExamCreatorContext";
import getExamSectionMap from "../../../Util/functions/ExamCreatorHelperFunctions/getExamSectionMap";

const CaseListFooter = ({
  selectedSectionIds,
  selectedExamId,
  handleRandomClick,
}) => {
  const { primaryColor, userData, premadeExams, customExams, examSections } =
    useContext(AppContext);
  const {
    examListView,
    setIsCaseDetailsPopupDisplayed,
    setCaseDetails,
    setExamListView,
    incompleteExams,
  } = useContext(ExamCreatorContext);

  const moveSectionIntoViewHandler = (sectionID) => {
    const section = document.getElementById(`section-${sectionID}`);
    if (section) {
      section.scrollIntoView({
        behavior: userData.AnimationsDisabled ? "auto" : "smooth",
        block: "center",
      });
    }
  };

  const examSectionMap = useMemo(
    () => getExamSectionMap(examSections),
    [examSections]
  );

  const getCustomCaseDetails = () => {
    const getPreviousCompletionScore = (sectionIds) => {
      // Find the customExam with the same array of sectionIds
      const customExam = customExams.find(
        (exam) =>
          exam.sections.length === sectionIds.length &&
          exam.sections.every((section) =>
            sectionIds.includes(section.sectionId)
          )
      );

      return customExam ? customExam.MostRecentCompletionScore : 0;
    };

    const customSelectedSections = selectedSectionIds.map(
      (sectionId) => examSectionMap[sectionId]
    );

    const customMostRecentCompletionDate = customSelectedSections.reduce(
      (mostRecentDate, section) => {
        if (section.LastCompletionDate > mostRecentDate) {
          return section.LastCompletionDate;
        } else {
          return mostRecentDate;
        }
      },
      ""
    );

    let customCaseDetails = {
      Completed: customSelectedSections.every((section) => section.Completed),
      ExamId: null,
      ExamTitle: null,
      IncompleteAttempts: [],
      MostRecentCompletionDate: customMostRecentCompletionDate,
      MostRecentCompletionScore: getPreviousCompletionScore(selectedSectionIds),
      ReviewLater: customSelectedSections.every(
        (section) => section.ReviewLaterFlag
      ),
      ReviewLaterOutstanding: false,
      sectionIds: selectedSectionIds,
      sections: customSelectedSections,
    };

    return customCaseDetails;
  };

  const handleStartCaseClick = () => {
    if (examListView === "Premade Exams") {
      const newSelectedCaseIndex = premadeExams.findIndex(
        (exam) => exam.ExamId === selectedExamId
      );
      setCaseDetails(premadeExams[newSelectedCaseIndex]);
    } else if (examListView === "Exam Sections") {
      const customCaseDetails = getCustomCaseDetails();
      setCaseDetails(customCaseDetails);
    } else if (examListView === "Incomplete") {
      const newSelectedCaseIndex = incompleteExams.findIndex(
        (exam) => exam.ExamId === selectedExamId
      );
      console.log(
        "Setting case details",
        incompleteExams[newSelectedCaseIndex]
      );
      console.log("Incomplete exam id", selectedExamId);
      setCaseDetails(incompleteExams[newSelectedCaseIndex]);
    } else {
      const newSelectedCaseIndex = customExams.findIndex(
        (exam) => exam.ExamId === selectedExamId
      );
      setCaseDetails(customExams[newSelectedCaseIndex]);
    }

    setIsCaseDetailsPopupDisplayed(true);
  };

  const getCategoryFromSectionId = (sectionId) => {
    return examSectionMap[sectionId].sectionCategory;
  };

  const isStartExamButtonDisabled = () => {
    if (examListView === "Exam Sections")
      return selectedSectionIds.length === 0;
    else return !selectedExamId;
  };

  const isRandomExamButtonDisabled = () => {
    if (examListView === "Exam Sections") return examSections.length === 0;
    else if (examListView === "Premade Exams") return premadeExams.length === 0;
    else return customExams.length === 0;
  };

  return (
    <div className="caseListFooterContainer">
      {examListView === "Exam Sections" && (
        <div className="caseListFooterSelectedSectionsWrapper">
          <p className="caseListFooterSelectedSectionsText">
            Selected Sections ({selectedSectionIds.length})
          </p>
          <div className="caseListFooterSelectedSectionsContainer">
            {selectedSectionIds
              .sort((a, b) => a - b)
              .map((sectionId, index) => (
                <div
                  className="caseListFooterSelectedSection"
                  key={`Caselist-Footer-Section-${sectionId}-${index}`}
                  onClick={() => moveSectionIntoViewHandler(sectionId)}
                >
                  <p className="caseListFooterSelectedSectionNumber">
                    {sectionId}
                  </p>
                  <div className="caseListFooterSelectedSectionIconWrapper">
                    <FontAwesomeIcon
                      icon={getIconFromCategoryString(
                        getCategoryFromSectionId(sectionId)
                      )}
                      className="caseListFooterSelectedSectionIcon"
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
      <div className="caseListFooterButtonsWrapper">
        {examListView != "Incomplete" && (
          <button
            className={`caseListFooterButton secondaryButton`}
            onClick={() => {
              setExamListView("Incomplete");
            }}
            type="button"
          >
            Incomplete Exams
          </button>
        )}
        <button
          className={`caseListFooterButton secondaryButton${
            isRandomExamButtonDisabled() ? " buttonDisabled" : ""
          }`}
          onClick={handleRandomClick}
          disabled={isRandomExamButtonDisabled()}
          type="button"
        >
          {examListView === "Exam Sections" ? "Create" : "Select"} Random Exam
        </button>
        {examListView != "Incomplete" && (
          <button
            className={`caseListFooterButton primaryButton${
              isStartExamButtonDisabled() ? " buttonDisabled" : ""
            }`}
            onClick={handleStartCaseClick}
            type="button"
            disabled={isStartExamButtonDisabled()}
          >
            View Exam
          </button>
        )}
        {examListView == "Incomplete" && (
          <button
            className={`caseListFooterButton primaryButton${
              isStartExamButtonDisabled() ? " buttonDisabled" : ""
            }`}
            onClick={handleStartCaseClick}
            type="button"
            disabled={isStartExamButtonDisabled()}
          >
            Continue Exam
          </button>
        )}
      </div>
    </div>
  );
};

export default CaseListFooter;
